import { render, staticRenderFns } from "./AddUpdateTeam.vue?vue&type=template&id=5819ba9c&scoped=true&"
import script from "./AddUpdateTeam.vue?vue&type=script&lang=js&"
export * from "./AddUpdateTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5819ba9c",
  null
  
)

export default component.exports